'use client'

import { createContext, useContext } from 'react'
import { type FeatureFlags } from '../flags'

const FeatureFlagsContext = createContext<FeatureFlags>({
  snowyRunnerEnabled: true,
  isHalloween: false,
  isThanksgiving: false,
  isChristmas: false,
  isValentine: false,
  isCNY: false,
  isAprilFools: false,
  isPride: false,
  isBasketball: false,
  isBirthday: false,
  fetchStorySD: true,
  pvfBegEnabled: false,
  gamesToutEnabled: true,
})

export const useFeatureFlags = () => useContext(FeatureFlagsContext)

export default function FeatureFlagsProvider({ flags, children }: { flags: FeatureFlags; children: React.ReactNode }) {
  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>
}
